// 手机号脱敏
const telephoneShow = function (number) {
  if (number.length == 0) {
    return ''
  }
  var result = ''
  if (number.length > 7) {
    result = number.replace(/(\d{3})\d*(\d{4})/, "$1****$2")
  } else {
    result = number.slice(0, 3) + "****" + number.slice(3, number.length)
  }
  return result
}

// 邮箱脱敏
const emailShow = function (email) {
  if (email.length == 0) {
    return ''
  }
  var result = ''
  let str = email.split("@")
  result = str[0].substr(0, 2) + "***@" + str[1];
  return result
}

const fixNumber = function (value, unit) {
  var value = parseFloat(value).toFixed(9);
  var unit = unit || 0;
  var isInt = value.indexOf(".") == -1 ? true : false;
  var intNum = value.split(".")[0];
  var floatNum = !isInt ? value.split(".")[1] : "0";
  var floatArry = floatNum.split("");
  var newFloatNum = ".";
  for (var i = 0; i < unit; i++) {
    if (!floatArry[i]) {
      newFloatNum += "0"
    } else {
      newFloatNum += floatArry[i]
    }
  }
  if (unit > 0) {
    return parseFloat(intNum + newFloatNum).toFixed(unit)
  } else {
    return parseInt(intNum)
  }
};
const isEmail = function (str) {
  var emailReg = /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+.[a-zA-Z]{2,4}$/;
  return emailReg.test(str);
}

const isPhone = function (str) {
  var regExp = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
  return regExp.test(str);
}
// 判断是手机还是邮箱还是其他的
const checkUserType = function (userName) {
  var userType;
  if (isEmail(userName)) {
    userType = 2
  } else if (isPhone(userName)) {
    userType = 1
  } else {
    userType = 3
  }
  return userType
}
// 判断密码强度
const checkPwdStrength = function (pwd) {
  var level = 0, index = 1;
  if (pwd.length >= 6 && pwd.length <= 20) {
    //正则表达式验证符合要求的
    if (/\d/.test(pwd)) level++; //数字
    if (/[a-z]/.test(pwd)) level++; //小写
    if (/[A-Z]/.test(pwd)) level++; //大写
    if (/\W/.test(pwd)) level++; //特殊字符
    if (level > 1 && pwd.length > 12) level++;//超过12位并且两种组合以上
  }
  return level
}


const pushPhone = function (value) {
  var myreg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
  if (!myreg.test(value)) {
    return false;
  } else {
    return true;
  }
}

const pushEmail = function (value) {
  if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
    return false;
  } else {
    return true;
  }
}
const fixDecimal = function (value, unit) {
  var $this = this;
  var result = $this.fixNumber(value, unit);
  if (unit > 0) {
    result = parseFloat(result);
  } else {
    result = parseInt(result);
  }
  if (result > 0 && result < 0.000001) {
    //解决科学计数法显示问题，转为字符串
    result = $this.fixNumber(value, unit);
  }
  return result;
}
const getDateTime = function (timestamp, format) {

  var pad = function (val, len) {

    val = String(val);

    len = len || 2;

    while (val.length < len) val = "0" + val;

    return val;

  };

  var date = new Date(parseFloat(timestamp) * 1000);
  var year = date.getFullYear();

  var month = pad(date.getMonth() + 1);

  var day = pad(date.getDate());

  var hour = pad(date.getHours());

  var minutes = pad(date.getMinutes());

  var second = pad(date.getSeconds());
  switch (format) {
    case 'MM-DD HH:MM:SS':
      return [month, day].join('-') + ' ' + [hour, minutes, second].join(':');
      break;
    case 'YYYY-MM-DD HH:MM:SS':
      return [year, month, day].join('-') + ' ' + [hour, minutes, second].join(':');
      break;
    case 'YYYY-MM-DD':
      return [year, month, day].join('-');
      break;
    case 'HH:MM:SS':
      return [hour, minutes, second].join(':');
      break;
    case 'HH:MM':
      return [hour, minutes].join(':');
      break;
    case 'array':
      return [year, month, day, hour, minutes, second];
      break;
    default:
      return [year, month, day].join('') + ' ' + [hour, minutes, second].join(':');
      break;
  }
}
/** 小数相乘 */
const numMultiply = function (arg1, arg2) {
  var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length
  } catch (e) {
  }
  try {
    m += s2.split(".")[1].length
  } catch (e) {
  }
  var tradeAmount = Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
  return tradeAmount;
}
const preHandle = function (n1, n2) { //#noadd
  if (!((typeof n1 === 'number' || (typeof n1 === 'string' && /^[\d]+(\.[\d]+)?$/g.test(n1))) &&
    (typeof n2 === 'number' || (typeof n2 === 'string' && /^[\d]+(\.[\d]+)?$/g.test(n2)))
  )) {
    return NaN;
  }
  var s1 = n1.toString(), s2 = n2.toString(), a1 = s1.split("."), a2 = s2.split(".");
  s1 = s1.replace(".", "");
  s2 = s2.replace(".", "");
  return {
    s1: s1,
    s2: s2,
    n1: parseInt(s1, 10),
    n2: parseInt(s2, 10),
    d1: a1.length > 1 ? a1[1].length : 0, //小数部分长度
    d2: a2.length > 1 ? a2[1].length : 0//小数部分长度
  };
}
// 除法运算
const numDivide = function (n1, n2) {
  var oT = preHandle(n1, n2),
    out = !(oT === oT) ? oT : (oT.n1 / oT.n2 / Math.pow(10, oT.d1 - oT.d2));
  return parseFloat(out);
}

// 加法
const accAdd = function (arg1, arg2) {
  var r1, r2, m;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (arg1 * m + arg2 * m) / m;
}

//减法函数
const Subtr = function (arg1, arg2) {
  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  //last modify by deeka
  //动态控制精度长度
  n = (r1 >= r2) ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

//给Number类型增加一个add方法，，使用时直接用 .sub 即可完成计算。
Number.prototype.sub = function (arg) {
  return Subtr(this, arg);
};
//检测价格和数量的小数位
const checkDecimal = function (value, unit) {
  if ($.isNumeric(value) && value >= 0) {
    var valueStr = value + "";
    if (valueStr.indexOf(".") != -1) {
      var newStr,
        intStr = valueStr.split(".")[0] + "",
        floatStr = valueStr.split(".")[1] + "";
      //处理整数
      if (unit == 0) {
        return intStr;
      } else {
        if (floatStr.split("").length > unit) {
          newStr = intStr + "." + floatStr.substr(0, unit);
          return newStr;
        }
      }
    }
  } else {
    return '';
  }
}
// 获取特定 cookie 的值

const getCookie = function (name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}
// 设置 cookie
const setCookie = function (name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + ";domain=.Alicms.com; path=/";
}


export default {
  fixNumber,
  isEmail,
  isPhone,
  checkUserType,
  checkPwdStrength,
  pushPhone,
  pushEmail,
  fixDecimal,
  getDateTime,
  numMultiply,
  numDivide,
  checkDecimal,
  getCookie,
  setCookie,
  Subtr,
  accAdd,
  telephoneShow,
  emailShow

}



// WEBPACK FOOTER //
// ./src/utils/methods.js